/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:30:20
 * @LastEditTime: 2019-11-05 16:46:16
 * @LastEditors: he.jianbo
 */
'use strict';
angular.module('productManageMentWeiboModule', ['productManageMentWeiboServiceModule'])
    .controller('productManageMentWeiboCtrl', ['$scope', '$timeout', 'trsHttpService', 'modalDialog', 'productManageMentWeiboService', 'permissionService', '$q', 'productManagementWeixinService', 'productManageMentService',
        function($scope, $timeout, trsHttpService, modalDialog, productManageMentWeiboService, permissionService, $q, productManagementWeixinService, productManageMentService) {
            initStatus();
            initData();
            window.addEventListener('storage', function(e) {
                event(e);
            });
            var event = function(e) {
                $timeout(function() {
                    if (e.key == 'weibo.refresh') {
                        requestData();
                    }
                }, 1);
            };
            $scope.$on('$destroy', function() {
                event = function() {
                };
            });

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {

                /**
                 * [page description:分页信息]
                 */
                $scope.page = {
                    'CURRPAGE': 1,
                    'PAGESIZE': 12,
                    'ITEMCOUNT': 0,
                    'PAGECOUNT': 1,
                };
                $scope.status = {
                    copyCurrPage: 1,
                    params: {
                        'serviceid': 'wcm61_scmaccount',
                        'methodname': 'findAccountsOfManagerToJson',
                        'AccountName': '',
                        'PageSize': $scope.page.PAGESIZE,
                        'CurrPage': $scope.page.CURRPAGE,
                    },
                    isAdministrator: false,
                    rights: {},
                };
                $scope.data = {
                    items: [],
                    selectedArray: [],
                };
                $scope.searchWord = '';

                /**
                 * 判断是否是管理员
                 */
                permissionService.isTenantAdministrator().then(function(data) {
                    $scope.status.isAdministrator = data;
                });
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                requestData();
            }

            /**
             * [requestData description]挂载
             *
             * @return  {[type]}  [return description]
             */
            $scope.requestData = function () {
                requestData();
            };

            /**
             * [requestData description] 请求数据
             * @return {[type]} [description]
             */
            function requestData() {
                $scope.data.selectedArray = [];
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/rbcenter.do', $scope.status.params, 'post').then(function(data) {
                    $scope.data.items = data.DATA;
                    !!data.PAGER ? $scope.page = data.PAGER : $scope.page.ITEMCOUNT = '0';
                });
            }

            /**
             * [searchRequestData description]搜索
             *
             * @param   {[type]}  ev  [ev description]
             *
             * @return  {[type]}      [return description]
             */
            $scope.searchRequestData = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    $scope.status.params.AccountName = $scope.searchWord;
                    requestData();
                }
            };

            /**
             * [modifyAccount description] 编辑账号信息
             *
             * @param   {[type]}  item   [item description]
             * @param   {[type]}  right  [right description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.modifyAccount = function(item, right) {
                productManageMentWeiboService.edit(item, right, function(result) {
                    if (result == 'success') {
                        modalDialog.alertType('编辑成功', '', 'success', false);
                        requestData();
                    } else if (result == 'successNeedConfirm') {
                        modalDialog.alertType('提示信息', '是否绑定完成？', 'ask', true, function() {
                            requestData();
                        });
                    } else {
                        modalDialog.alertType(result.detail, result.detail == result.message ? '' : result.message, 'error', false);
                    }
                });
            };

            /**
             * [create description] 新增微博账号
             * @return {[type]} [description]
             */
            $scope.create = function() {
                window.open('/wcm/app/scm/sina_authorized.jsp?CheckFgdAttribute=');
                $timeout(function() {
                    productManagementWeixinService.newWechatBindModel('/wcm/app/scm/sina_authorized.jsp?CheckFgdAttribute=').then((result) => {
                        requestData();
                    });
                }, 500);
                // productManageMentWeiboService.AccountAdd(function(result) {
                //     if (result == 'success') {
                //         modalDialog.alertType('创建成功', '', 'success', false);
                //         requestData();
                //     } else {
                //         modalDialog.alertType('您的账号绑定微博账号并自动授权延期失败，原因可能如下:', '1.微博登录账号或者密码错误\n2.如账号密码正常，则需要跳转至新浪微博认证页面进行认证，并且无法自动续期，如需要自动续期，您可以在该页面的【操作】-【编辑】中手动延期，\n跳转至微博授权页面点击【确认】，取消授权点击【取消】', 'ask', true, function() {
                //             window.open('/wcm/app/scm/sina_authorized.jsp?CheckFgdAttribute=' + result.checkFgdAttribute);
                //             modalDialog.alertType('提示信息', '是否绑定完成？', 'ask', true, function() {
                //                 requestData();
                //             });
                //         });
                //     }
                // });
            };

            /**
             * [authbind description] 微博视频发布认证
             *
             * @param   {[type]}  objectId   [objectId description]
             * @param   {[type]}  loginName  [loginName description]
             *
             * @return  {[type]}             [return description]
             */
            $scope.authbind = function(objectId, loginName) {

                if (loginName && loginName !== '') {

                    return;
                }

                // var options = {
                //     objectId: objectId
                // };
                // productManageMentWeiboService.AccountBind(function(result) {
                //     if (result == 'success') {
                //         modalDialog.alertType('绑定成功', '', 'success', false);
                //         requestData();
                //     } else {
                //         modalDialog.alertType('您的账号认证失败，原因可能如下:', '1.微博登录账号或者密码错误', 'ask', true, function() {
                //             modalDialog.alertType('提示信息', '是否绑定完成？', 'ask', true, function() {
                //                 requestData();
                //             });
                //         });
                //     }
                // }, options);
                var params = {
                    serviceid: 'wcm61_scmaccount',
                    methodname: 'getAuthorizedUrl',
                    mediaChannel: 'YUNJIAN',
                    accountId: objectId,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    window.open(data.URL);
                });
            };

            /**
             * [sortAccount description] 微博账号排序
             * @return {[type]} [description]
             */
            $scope.sortAccount = function() {
                if ($scope.data.selectedArray.length > 1) {
                    modalDialog.alertType('请选择一个微博账号', '', 'warning', false);
                    return;
                } else {
                    if ($scope.data.selectedArray[0].rights.edit) {
                        productManageMentWeiboService.sort($scope.data.selectedArray[0], function(result) {
                            if (result == 'success') {
                                modalDialog.alertType('排序成功', '', 'success', false);
                                requestData();
                            } else {
                                modalDialog.alertType(result.detail, result.detail == result.message ? '' : result.message, 'error', false);
                            }
                        });
                    } else {
                        modalDialog.alertType('该微博账号没有编辑权限', '', 'error', false);
                    }
                }
            };

            /**
             * [deleteAccount description]删除账号
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.deleteAccount = function(item) {
                var tips = '';
                if (angular.isUndefined(item)) {
                    weiboDeleteBatch();
                } else {
                    modalDialog.alertType('提示信息', '您确定要删除此微博账号', 'ask', true, function() {
                        deleteWeiboAccountMethod(item.ACCOUNTID);
                    });
                }
            };

            /**
             * [weiboDeleteBatch description] 微博账号批量删除
             * @return {[type]} [description]
             */
            function weiboDeleteBatch() {
                var hasRightArr = [],
                    item = '';
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    if ($scope.data.selectedArray[i].rights.delete) {
                        hasRightArr.push($scope.data.selectedArray[i]);
                    }
                }
                if (hasRightArr.length == 0) {
                    modalDialog.alertType('所选微博账号没有删除权限', '', 'error', false);
                } else if (hasRightArr.length == $scope.data.selectedArray.length) {
                    item = hasRightArr.map(function(item) {
                        return item.ACCOUNTID;
                    }).join(',');
                    modalDialog.alertType('您确定要删除' + hasRightArr.length + '个微博账号', hasRightArr.map(function(item) {
                        return item.ACCOUNTNAME;
                    }).join(','), 'ask', true, function() {
                        deleteWeiboAccountMethod(item);
                    });
                } else {
                    item = hasRightArr.map(function(item) {
                        return item.ACCOUNTID;
                    }).join(',');
                    modalDialog.alertType('部分微博账号没有删除权限，是否删除以下微博账号', hasRightArr.map(function(item) {
                        return item.ACCOUNTNAME;
                    }).join(','), 'ask', true, function() {
                        deleteWeiboAccountMethod(item);
                    });
                }
            }

            /**
             * [deleteWeiboAccountMethod description]删除账号方法
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            function deleteWeiboAccountMethod(item) {
                $scope.params = {
                    serviceid: 'wcm61_scmaccount',
                    methodname: 'deleteSinaAccountToJson',
                    AccountIds: item,
                };
                trsHttpService.httpServer('/wcm/rbcenter.do', $scope.params, 'get').then(function(data) {
                    modalDialog.alertType('删除成功', '', 'success', false);
                    requestData();
                });
            }

            /**
             * [pageChanged description]下一页
             *
             * @return  {[type]}  [return description]
             */
            $scope.pageChanged = function() {
                $scope.status.params.CurrPage = $scope.page.CURRPAGE;
                $scope.status.copyCurrPage = $scope.page.CURRPAGE;
                requestData();
            };

            /**
             * [jumpToPage description]跳转指定页面
             *
             * @return  {[type]}  [return description]
             */
            $scope.jumpToPage = function() {
                if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                    $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
                }
                $scope.status.params.CurrPage = $scope.status.copyCurrPage;
                $scope.page.CURRPAGE = $scope.status.copyCurrPage;
                requestData();
            };

            /**
             * [getWeiboRights description]获取微博权限
             *
             * @param   {[type]}  item  [item description]
             *
             * @return  {[type]}        [return description]
             */
            function getWeiboRights(item) {
                productManageMentWeiboService.getRight(item.ACCOUNTID, 'microblogset.blog').then(function(data) {
                    item.rights = data;

                });
            }

            /**
             * [channelFormat description]渠道显示格式化
             *
             * @param   {[type]}  platForm  [platForm description]微博渠道
             *
             * @return  {[type]}            [return description]
             */
            $scope.channelFormat = function(platForm) {
                if (platForm == 'sina' || platForm == 'Sina') {
                    return '新浪微博';
                } else {
                    return '';
                }
            };

            /**
             * [statusFormat description]微博账号状态显示格式化
             *
             * @param   {[type]}  overtime  [overtime description]账号状态
             *
             * @return  {[type]}            [return description]
             */
            $scope.statusFormat = function(overtime) {
                var curTime = new Date();
                // 把字符串格式转化为日期类
                var endTime = new Date(Date.parse(overtime));
                if (curTime > endTime) {
                    return '延期失效';
                } else {
                    return '延期正常';
                }
            };

            /**
             * [videoPublishstatusFormat description]微博视频发布认证状态显示格式化
             *
             * @param   {[type]}  loginName  [loginName description]视频发布认证状态
             *
             * @return  {[type]}             [return description]
             */
            $scope.videoPublishstatusFormat = function(loginName) {

                if (!loginName || loginName === '') {
                    return '未认证';
                } else {
                    return '已认证';
                }
            };

            /**
             * [watermarkMGR description]跳转到水印管理页面
             *
             * @param   {[type]}  item    [item description]
             * @param   {[type]}  trench  [trench description]
             *
             * @return  {[type]}          [return description]
             */
            $scope.watermarkMGR = function (item, trench) {
                productManageMentService.toWatermarkMGR(item, trench);
            };

            /**
             * [selectDoc description] 选择/取消选择微博
             * @param  {[Object]} item [description] 微博对象
             * @return {[type]}      [description]
             */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
            };

            /**
             * [selectAll description] 微博全选/全不选
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            };

            /**
             * [itenInit description] 微博账号index值初始化
             * @param  {[Object]} item   [description] 微博账号
             * @param  {[Number]} $index [description] 微博顺序
             * @return {[type]}        [description]
             */
            $scope.itemInit = function(item, $index) {
                item.index = $index + 1 + ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE;
                getWeiboRights(item);
            };

            /**
             * [headPicload description] 头像未能正常显示时显示默认头像
             * @param  {[object]} item [description] 微博账号对象
             * @return {[type]}      [description]
             */
            $scope.headPicload = function(item) {
                var imgObj = new Image();
                imgObj.src = item.HEADPIC;
                imgObj.onload = function() {
                    item.picUrl = item.HEADPIC;
                };
                imgObj.onerror = function() {
                    item.picUrl = './images/user_icon.jpg';
                };
            };
        },
    ]);
